export const formatInterventionTimestamp = (
  timestamp: string,
  locale: string,
  timeZone: string,
) =>
  new Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone,
  }).format(new Date(timestamp));
